import { Layout } from 'antd';
import { useLocation } from "react-router-dom";
import PageHeader from "../header/index";
import EmptyHeader from "../emptyheader";
import PageFooter from "../footer/";
import './index.less';
import { storage } from '@/utils/storage';
import AiFloatButton from '@/pages/aiFloatBtn/index';
import '@/pages/aiFloatBtn/index.less';
const { Header, Footer, Content, } = Layout;
export default function Index(props) {
  const { children } = props;
  const location = useLocation();
  const isPrint = location.pathname.includes('print');
  const token = storage.get('token');

  return <Layout>
    {!isPrint && (token ? <Header className="page-layout-header"><PageHeader /></Header> : <EmptyHeader />)}
    <Content className="page-layout-content">{children}</Content>
    {/* 全局AI悬浮按钮 */}
    {!isPrint && <AiFloatButton />}
    {!isPrint && <Footer className="page-layout-footer"><PageFooter /></Footer>}
  </Layout>;
};